import React from "react";
import project1 from "./../assets/jlpl-1.jpeg";
import project2 from "./../assets/dark-shed.avif";
import project3 from "./../assets/patiala-school.jpeg";
import project4 from "./../assets/india-cements-b.jpeg";
import project5 from "./../assets/b12.jpeg";
import project6 from "./../assets/project-2.jpeg";
import project7 from "./../assets/cover-1.jpg";
import project8 from "./../assets/tank.jpeg";
import "./ProjectsList.css";

const ProjectsList = () => {
  return (
    <div className="projects-list-container">
      <div className="project-detail">
        <img src={project1} alt="" />
        <div className="project-detail-header">16 STOREY BUILDING FOR JLPL AT MOHALI</div>
      </div>
      <div className="project-detail">
        <img src={project2} alt="" style={{'filter': 'brightness(100%)'}} />
        <div className="project-detail-header">HAVELLS INDUSTRIAL SHED AT BADDI (H.P)</div>
      </div>
      <div className="project-detail">
        <img src={project3} alt="" />
        <div className="project-detail-header">CONVENT SCHOOL AT PATIALA (PUNJAB)</div>
      </div>
      <div className="project-detail">
        <img src={project4} alt="" />
        <div className="project-detail-header">7 STOREY SOCIETY BUILDING FOR INDIA CEMENTS IN MEGHALAYA</div>
      </div>
      <div className="project-detail">
        <img src={project5} alt="" />
        <div className="project-detail-header">12 STOREY SOHI TOWER AT ZIRAKPUR</div>
      </div>
      <div className="project-detail">
        <img src={project6} alt="" />
        <div className="project-detail-header">14 MARLA HOUSE AT KARNAL</div>
      </div>
      <div className="project-detail">
        <div className="project-detail-header">MARKETING OFFICER BUILDING FOR JAIPURIA CONSTRUCTION AT ZIRAKPUR, PUNJAB</div>
        <img src={project7} alt="" />
      </div>
      <div className="project-detail">
        <div className="project-detail-header">UNDERGROUND WATER TANK OF 10 LAC LITRE CAPACITY FOR HUDA AT SECTOR 3, PANCHKULA</div>
        <img src={project8} alt="" />
      </div>
    </div>
  );
};

export default ProjectsList;
